// Canonical business / legal identity for Zopeo.
// Mirrors marketing-site/lib/businessProfile.ts so the policy content shown in
// the merchant portal matches the public marketing site that Razorpay reviews.
export const BUSINESS_PROFILE = {
  brandName: 'Zopeo',
  proprietorName: 'Sai Varun Thupakula',
  legalEntityLabel: 'sole proprietor, operating as "Zopeo"',
  registeredAddress: '2-108/3/25/A, Sri Sai Enclave - 2, Boduppal, Hyderabad - 500092',
  cityAndState: 'Hyderabad, Telangana',
  country: 'India',
  supportEmail: 'hello@zopeo.in',
  supportPhone: '+91 9398246049',
  supportHours: 'Monday to Saturday',
  gstStatus: 'Not registered for GST',
  disputeWindowDays: 15,
  refundProcessingWindow: '5-7 business days',
  serviceActivationWindow: 'within 1 day after successful payment and account verification',
  websiteUrl: 'https://zopeo.in'
};

export const RAZORPAY_APPLICATION_DETAILS = {
  businessType: 'Individual / Sole Proprietorship',
  category: 'Software / SaaS / IT Services / Business Services',
  description:
    'Zopeo is a B2B software platform for Indian merchants. It helps businesses manage appointments, customer engagement, offers, memberships, analytics, and merchant billing. Merchants pay Zopeo for software subscription or usage fees. Zopeo does not charge end customers directly and does not hold customer funds.'
};
